module.exports = __webpack_public_path__ + "img/social-lead-first-bg.b18f480d.jpg";